import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'
import styles from './index.module.scss'

type Props = {
  fontSize?: 'middle' | 'large'
}

export const Tag: FC<PropsWithChildren<Props>> = ({ fontSize = 'middle', children }) => {
  const className = classNames(styles.text, {
    [styles.middle]: fontSize === 'middle',
    [styles.large]: fontSize === 'large',
  })
  return (
    <div className={styles.container}>
      <div className={className}>{children}</div>
    </div>
  )
}
